var m = require('mithril');
var formGroup = require('../formGroup');

var component = {};

component.view = function view (vnode) {
  return m(formGroup, [
    m('label', {for: (vnode.attrs.field.id || 'number') + '-input'}, vnode.attrs.field.name),
    m("select", {
      oninput: (ev) => { vnode.attrs.prop(ev.target.value) },
      value: vnode.attrs.prop(),
    }, vnode.attrs.field['options'].map(function (option) {
      return m("option", { value: option.value }, option.name)
    }))
  ])
};

module.exports = component;
